import { collection, getDocs, onSnapshot, orderBy, query } from 'firebase/firestore';

import { FSCollections } from '@src/constants/database';
import { db } from '@src/firebase/firebase';
import type { EmergencyTimelineFirestoreRecord } from '@src/models/interfaces/emergency.interface';

import { toFirestoreRecord } from './emergencyRepository.utils';

export class EmergencyTimelineRepository {
  subscribe(
    organizationId: string,
    incidentId: string,
    onData: (records: EmergencyTimelineFirestoreRecord[]) => void,
    onError: (error: Error) => void,
  ): () => void {
    return onSnapshot(
      query(
        collection(
          db,
          FSCollections.ORGANIZATIONS,
          organizationId,
          FSCollections.EMERGENCIES,
          incidentId,
          FSCollections.EMERGENCY_TIMELINE_EVENTS,
        ),
        orderBy('createdAt', 'asc'),
      ),
      snapshot =>
        onData(
          snapshot.docs.map(document =>
            toFirestoreRecord<EmergencyTimelineFirestoreRecord>(document),
          ),
        ),
      onError,
    );
  }

  async list(
    organizationId: string,
    incidentId: string,
  ): Promise<EmergencyTimelineFirestoreRecord[]> {
    const timelineQuery = query(
      collection(
        db,
        FSCollections.ORGANIZATIONS,
        organizationId,
        FSCollections.EMERGENCIES,
        incidentId,
        FSCollections.EMERGENCY_TIMELINE_EVENTS,
      ),
      orderBy('createdAt', 'asc'),
    );
    const snapshot = await getDocs(timelineQuery);
    return snapshot.docs.map(docSnapshot =>
      toFirestoreRecord<EmergencyTimelineFirestoreRecord>(docSnapshot),
    );
  }
}
